<template>
	<validation-provider
			:name="'AdminSelectTrainingSectionCode-' + contentKey + '-' + inputItemKey"
			:rules="getValidationRules(contents[contentKey].inputItems[inputItemKey].rules)"
			v-slot="{ errors }">
		<v-autocomplete
				v-model="$store.state.admin.input[inputItemKey]"
				:items="arrayObject($_admnSlctTrnSctId_stateAdminTrainings())"
				item-text="key"
				item-value="key"
				placeholder="Training Section Code"
				@change="$_admnSlctTrnSctId_setAdminState()"
				:error-messages="errors" />
	</validation-provider>
</template>

<script>
	export default {
		name: 'AdminSelectTrainingSectionCode',
		props: {
			contentKey: String,
			inputItemKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			$_admnSlctTrnSctId_stateAdminTrainings() {
				const self_ = this;
				return () => {
					const input_ = self_.getAdminState('input')
					const courseCode_ = input_.trainingCourseCode;
					const moduleCode_ = input_.trainingModuleCode;

					if(self_.isFalse(courseCode_) || self_.isFalse(moduleCode_)) { return null }

					const trainings_ = self_.getAdminState('trainings')
					return trainings_[courseCode_].modules[moduleCode_].sections
				}
			}
		},
		methods: {
			$_admnSlctTrnSctId_getTraining(param) {
				const self_ = this;

				const trainings_ = self_.getAdminState('trainings')

				const input_ = self_.getAdminState('input')
				const courseCode_ = input_.trainingCourseCode;
				const moduleCode_ = input_.trainingModuleCode;
				const sectionCode_ = input_[self_.inputItemKey]
				if(self_.isFalse(courseCode_) || self_.isFalse(moduleCode_) || self_.isFalse(sectionCode_)) { return null }

				return trainings_[courseCode_].modules[moduleCode_].sections[sectionCode_][param]
			},
			$_admnSlctTrnSctId_setAdminState() {
				const self_ = this;

				let input_ = self_.getAdminState('input')
				input_.trainingSectionTitle = self_.getLangsVal(self_.$_admnSlctTrnSctId_getTraining('title'))

				self_.setAdminState('input', input_)
			}
		}
	}
</script>

<style scoped>
</style>
